import Repository from '../Repository';

const resource = 'newsletter/listing';

export default {
  createSubscription(listingId, payload) {
    return Repository.post(resource + '/' + listingId + '/subscribe', payload)
  },
  unSubscribe(subscriptionId) {
    return Repository.delete( 'newsletter/subscription/' + subscriptionId)
  }
}
